export default "__VITE_ASSET__3$Vfyx$Y__"